<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted } from 'vue'
import { useAuthStore } from '@/modules/auth/stores/useAuthStore'
import { useChatAssistant } from '../composables/useChatAssistant'
import AiChatFab from './AiChatFab.vue'
import AiChatPanel from './AiChatPanel.vue'

const authStore = useAuthStore()
const hasAdminRole = computed(() => authStore.isAdmin)

// Hide AI chat when any slide-over (HeadlessUI Dialog) is open
const hasOpenDialog = ref(false)
let observer: MutationObserver | null = null

function checkForDialogs() {
  hasOpenDialog.value = document.querySelectorAll('[role="dialog"]').length > 0
}

onMounted(() => {
  observer = new MutationObserver(checkForDialogs)
  observer.observe(document.body, { childList: true, subtree: true })
})

onUnmounted(() => {
  observer?.disconnect()
})
const {
  isOpen,
  messages,
  inputText,
  isLoading,
  error,
  toggle,
  close,
  sendMessage,
  clearHistory
} = useChatAssistant()
</script>

<template>
  <template v-if="hasAdminRole && !hasOpenDialog">
    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="opacity-0 translate-y-4 scale-95"
      enter-to-class="opacity-100 translate-y-0 scale-100"
      leave-active-class="transition duration-150 ease-in"
      leave-from-class="opacity-100 translate-y-0 scale-100"
      leave-to-class="opacity-0 translate-y-4 scale-95"
    >
      <AiChatPanel
        v-if="isOpen"
        v-model:input-text="inputText"
        :messages="messages"
        :is-loading="isLoading"
        :error="error"
        @send="sendMessage"
        @clear="clearHistory"
        @close="close"
      />
    </transition>
    <AiChatFab :is-open="isOpen" @toggle="toggle" />
  </template>
</template>
